import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';
import React from 'react';
import SimpleImageLoader from '../SimpleImageLoader';
import SimpleMenu from '../SimpleMenu/SimpleMenu';

const useStyles = makeStyles((theme: any) => ({
    avatar: {
        backgroundColor: red[500],
    },
    card: (props: any) => ({
        cursor: props.handleClick ? 'pointer' : 'none',
        flex: 1,
        height: '235px',
        width: '100%',
    }),
    cardHeader: (post: any) => ({
        backgroundColor: post.removedByAdmin ? 'red' : theme.palette.primary.main,
        color: theme.palette.common.white,
    }),
    content: {},
    expand: {
        marginLeft: 'auto',
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    flag: (post: any) => ({
        color: post.removedByAdmin === undefined || post.removedByAdmin === true ? 'red' : 'green',
    }),
    headerAction: {
        '& :hover': {
            color: theme.palette.common.white,
        },
        color: theme.palette.common.white,
    },
    media: {
        maxHeight: '100%',
        width: '100%',
    },
}));

interface ISimpleGram {
    /** Title to appear at top of the card */

    title?: string;
    /** Enable/disable visibilty of avatar */
    showAvatar?: boolean;

    /** src of the avatar */
    avatarSrc?: string;

    /** text fallback for avatar */

    avatarAlt?: string;
    /** Enable/disable visibilty of menu */
    showMenu?: boolean;

    /** Target to link to */
    handleClick?: any | undefined;
    /** timestamp to be displayed on card */
    timestamp?: string;
    /** Array of options the menu can be populated with */
    menuOptions?: [{ label: string; callback: Function }];

    /** function use to render content in the CardAction location */
    actionRender?: Function;

    /** imgage url for body of card */
    primaryImageUrl?: string;

    /** primary text content */
    primaryTextContent?: string;
}

const SimpleGram = (props: ISimpleGram) => {
    const classes = useStyles(props);
    const { handleClick } = props;
    const AvatarWrapper = () => {
        return (
            <Avatar color="primary">
                {props.avatarSrc ? (
                    <img alt="user avatar" src={props.avatarSrc} width="40" />
                ) : props.avatarAlt ? (
                    `${props.avatarAlt.charAt(0)}`
                ) : (
                    ''
                )}
            </Avatar>
        );
    };
    return (
        <React.Fragment>
            <Card className={classes.card} onClick={handleClick}>
                <CardHeader
                    action={
                        props.showMenu ? (
                            <SimpleMenu mode="dark" options={props.menuOptions ? props.menuOptions : undefined} />
                        ) : (
                            ''
                        )
                    }
                    avatar={props.showAvatar ? <AvatarWrapper /> : null}
                    classes={{ root: classes.cardHeader, action: classes.headerAction }}
                    subheader={props.timestamp ? props.timestamp : ''}
                    title={props.title}
                />

                <CardContent classes={{ root: classes.content }}>
                    {props.primaryImageUrl && (
                        <SimpleImageLoader
                            alt="Moment"
                            className={classes.media}
                            src={props.primaryImageUrl}
                            width={300}
                        />
                    )}

                    <Typography color="textSecondary" component="p" variant="body2">
                        {props.primaryTextContent}
                    </Typography>
                </CardContent>
                {props.actionRender && <CardActions>{props.actionRender()}</CardActions>}
            </Card>
        </React.Fragment>
    );
};
export default SimpleGram;
